<template>
  <div class="flow-editor">
    <!-- 左侧工具栏 -->
    <div class="toolbar">
      <v-btn
        small
        class="ma-1"
        @click="addNode('station')"
      >
        添加站
      </v-btn>
      <v-btn
        small
        class="ma-1"
        @click="addNode('roadmap')"
      >
        添加工艺
      </v-btn>
      <v-btn
        small
        class="ma-1"
        @click="exportJSON"
      >
        导出 JSON
      </v-btn>
    </div>

    <!-- 中间画布 -->
    <div
      ref="container"
      class="container"
    />
  </div>
</template>

<script>
  import LogicFlow from "@logicflow/core";
  import "@logicflow/core/lib/style/index.css";
  import StationShape from './stationShape';
  import RoadmapShape from './roadmapShape';

  export default {
    name: "Demo1",

    data() {
      return {
        selectedNode: null,
        stationId: 1,
        roadmapId: 1,
        renderData: {
          // 节点数据
          nodes: [
            {
              id: '21', // 节点ID，需要全局唯一，不传入内部会自动生成一个ID
              type: 'rect', // 节点类型，可以传入LogicFlow内置的7种节点类型，也可以注册自定义节点后传入自定义类型
              x: 300, // 节点形状中心在x轴位置
              y: 100, // 节点形状中心在y轴的位置
              text: 'Origin Usage-rect', // 节点文本
              properties: { // 自定义属性，用于存储需要这个节点携带的信息，可以传入宽高以重设节点的宽高
                width: 160,
                height: 80,
              }
            },
            {
              id: '50',
              type: 'circle',
              x: 300,
              y: 300,
              text: 'Origin Usage-circle',
              properties: {
                r: 60,
              }
            },
          ],
          // 边数据
          edges: [
            {
              id: 'rect-2-circle', // 边ID，性质与节点ID一样
              type: 'polyline', // 边类型
              sourceNodeId: '50', // 起始节点Id
              targetNodeId: '21', // 目标节点Id
            },
          ],
        }
      }
    },

    mounted() {
      this.lf = new LogicFlow({
        container: this.$refs.container,
        grid: true,
      });

      // 注册自定义节点
      this.lf.register(StationShape);
      this.lf.register(RoadmapShape);
      this.lf.render(this.renderData);

      this.lf.on("node:click", ({ data }) => {
        console.log("node:click", data);
        this.selectedNode = data;
      });

      // 监听节点拖动结束事件
      this.lf.on('node:drop', ({ data }) => {
        console.log("node:drop", data);
        const node = this.renderData.nodes.find(node => node.id === data.id);
        if (node) {
          node.x = data.x;
          node.y = data.y;
        }
      });

      // 锚点连线拖动觖发 新增连线
      // this.lf.on('anchor:drop', ({ data }) => {
      //   console.log("anchor:drop", data);
      //   const { sourceNodeId, targetNodeId } = data;
      //   const edge = this.renderData.edges.find(edge => edge.sourceNodeId === sourceNodeId && edge.targetNodeId === targetNodeId);
      //   if (!edge) {
      //     this.renderData.edges.push({
      //       id: sourceNodeId + '-' + targetNodeId,
      //       type: 'polyline',
      //       sourceNodeId,
      //       targetNodeId,
      //     });
      //   }
      // });
    },

    methods: {
      exportJSON() {
        console.log("exportJSON", this.renderData);
      },

      addNode(type) {
        if (type === 'station') {
          this.renderData.nodes.push({
            id: 'station' + this.stationId,
            type: 'station',
            x: 100,
            y: 100,
            text: '站点' + this.stationId,
            properties: {
              width: 160,
              height: 80,
            }
          });
          this.stationId = this.stationId + 1;
        } else if (type === 'roadmap') {
          this.renderData.nodes.push({
            id: 'roadmap' + this.roadmapId,
            type: 'roadmap',
            x: 300,
            y: 300,
            text: '工艺' + this.roadmapId,
            properties: {
              width: 160,
              height: 80,
            }
          });
          this.roadmapId = this.roadmapId + 1;

        }
        this.lf.render(this.renderData);

      },

    },
  }
</script>

<style lang="scss" scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

.container {
  width: 100%;
  grid-column: 1 / -1;
  height: 500px;
}

</style>